window.addEventListener("DOMContentLoaded", async () => {
  let isBuilderHydrated = false;

  const productData = await fetch("/products.json")
    .then((response) => response.json())
    .then((response) => response.products);
  const targetNode = document.querySelector(".main-content");
  const config = { attributes: true, childList: true, subtree: true };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        if (document.querySelector(".builder-hydrated")) {
          if (!isBuilderHydrated) {
            const productElements = getProductElements(productData);
            appendAddToBag(productElements, productData);
            isBuilderHydrated = true;
            observer.disconnect();
          }
        }
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});

function getProductElements(productData) {
  const pageLinks = Array.from(
    document.querySelectorAll(".builder-hydrated a")
  );

  const productElements = [];
  const productHandles = productData.map((product) => product.handle);
  const altProductHandles = productData.map((product) =>
    product.handle.split("-fl-").join("")
  );
  const renamedProductHandles = productData.map((product) =>
    product.handle.replace("32", "16")
  );
  const uniqueAltHandles = altProductHandles.filter(
    (handle) => !productHandles.includes(handle)
  );
  const uniqueRenamedHandles = renamedProductHandles.filter(
    (handle) => !productHandles.includes(handle)
  );

  const resolvedProductData = [
    ...productHandles,
    ...uniqueAltHandles,
    ...uniqueRenamedHandles,
  ];

  pageLinks.forEach((pageLink) => {
    resolvedProductData.forEach((productHandle) => {
      if (
        (pageLink.href.includes(productHandle) && productHandle !== "") ||
        pageLink.href.includes("/product/")
      ) {
        productElements.push(pageLink);
      }
    });
  });

  return productElements;
}

function appendAddToBag(productElements, productData) {
  const isDesktop = window.innerWidth > 769;

  // Modal functionality for mobile
  if (!isDesktop) {
    document.addEventListener("click", (event) => {
      if (
        !event.target.closest("a") ||
        (!event.target.closest("a").classList.contains("blog-product-link") &&
          !event.target.closest("a").classList.contains("product-title"))
      ) {
        productElements.forEach((productElement) => {
          productElement.classList.remove("active-link");
        });
      }
    });
  }

  productElements.forEach((productElement) => {
    productElement.classList.add("blog-product-link");
    let currentProduct = null;
    productData.forEach((product) => {
      if (
        productElement.href.includes(product.handle) ||
        productElement.href.includes(product.handle.split("-fl-").join("")) ||
        productElement.href.includes(product.handle.replace("32", "16"))
      ) {
        currentProduct = product;
      }
    });

    if (currentProduct) {
      productElement.removeAttribute("href");

      // Get reviews
      fetch(
        `https://api-cdn.yotpo.com/v1/widget/CfWNlPC1pjITWD0QVu2rTJcNGgQAfHBPbOyOvgQ1/products/${currentProduct.id}/reviews.json`
      )
        .then((response) => response.json())
        .then((reviews) => {
          const productDecimalRating =
            reviews.response.bottomline.average_score;
            
          //Append modal
          if (currentProduct.variants[0].available) {
            productElement.insertAdjacentHTML(
              "beforeend",
              `<div class="blog-quick-add-wrapper">
            <div class="blog-quick-add">
                <div class="blog-quick-add-content">
                    <img src="${currentProduct.images[0].src}" />
                <div>
                <a class="product-title" href="/products/${
                  currentProduct.handle
                }">${currentProduct?.title}</a>
                <div class="rating-wrapper">
                ${productDecimalRating ? createStars(productDecimalRating) : ''}
                <span aria-hidden="true" class="snippet-rating-decimal">${
                  (productDecimalRating && productDecimalRating != 0) ? productDecimalRating.toFixed(1) : ''
                }</span>
            </div>
             <button onclick="addToBag(${
              currentProduct.variants[0].id
            })" class="add-to-bag">
                    <div class="price-column">
                        <span>Add to Bag</span>
                        <span>$${currentProduct?.variants[0].price}</span>
                    </div>
                </button>
                </div>
            </div>
        </div>`
            );
          } else {
            productElement.insertAdjacentHTML(
              "beforeend",
              `<div class="blog-quick-add-wrapper">
                <div class="blog-quick-add">
                    <div class="blog-quick-add-content">
                        <img src="${currentProduct.images[0].src}" />
                    <div>
                    <a class="product-title" href="/products/${
                      currentProduct.handle
                    }">${currentProduct?.title}</a>
                    <div class="rating-wrapper">
                    ${productDecimalRating  ? createStars(productDecimalRating) : ''}
                    <span aria-hidden="true" class="snippet-rating-decimal">${
                      productDecimalRating ? productDecimalRating.toFixed(1): ''
                    }</span>
                </div>
                    <button class="add-to-bag add-to-bag-disabled">
                        <div class="price-column">
                            <span>OUT OF STOCK</span>
                            <span>$${currentProduct?.variants[0].price}</span>
                        </div>
                    </button>
                    </div>
                </div>
            </div>`
            );
          }
        });

      if (isDesktop) {
        // hover functionality
        productElement.addEventListener("mouseover", () => {
          productElement.classList.add("active-link");
        });
        productElement.addEventListener("mouseout", () => {
          productElement.classList.remove("active-link");
        });
      } else {
        // click functionality on mobile
        productElement.addEventListener("click", (event) => {
          const blogAddToBagModals =
            document.querySelectorAll(".blog-product-link");
          blogAddToBagModals.forEach((modal) =>
            modal.classList.remove("active-link")
          );
          productElement.classList.add("active-link");
          positionAddToBagModal(
            productElement.querySelector(".blog-quick-add-wrapper")
          );
        });
      }
    }
  });
}

function addToBag(variantId) {
  data = {
    quantity: 1,
    id: Number(variantId),
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      document.dispatchEvent(new CustomEvent("cart:build"));
      document.dispatchEvent(new CustomEvent("cart:open"));
    });
}

function positionAddToBagModal(modal) {
  const modalPosition = modal.getBoundingClientRect();
  if (modalPosition.left < 60) {
    modal.style.right = "-50px";
  }
}

function createStars(reviewCount) {
  // get the whole number of stars from the review count
  const wholeStars = Math.floor(reviewCount);
  // get the decimal value of the review count
  const decimal = reviewCount - wholeStars;
  // find the closest .25 value
  const closestQuarter = Math.round(decimal * 4) / 4;
  return `
      <div aria-hidden="true" class="rating-stars">
        ${Array(wholeStars)
          .fill(0)
          .map(() => '<div class="star-v4 star-v4-100-filled"></div>')
          .join("")}
          ${
            wholeStars ===  0
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
          ${
            wholeStars ===  1
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
          ${
            wholeStars ===  2
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
          ${
            wholeStars ===  3
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
        ${
          wholeStars === 4
            ? `<div class="star-v4 star-v4-${
                closestQuarter * 100
              }-filled"></div>`
            : ""
        }
      </div>
    `;
}
